// extracted by mini-css-extract-plugin
module.exports = {"bg-light-grey":"FooterMainFragment_bg-light-grey__3UPP8"};